import app from 'flarum/forum/app';
import { extend } from 'flarum/extend';
import EndWidgetSection from 'flarum/extensions/afrux-forum-widgets-core/forum/components/EndWidgetSection';
import IndexWidget from '../components/IndexWidget';
import AnnouncementDiscussion from '../components/AnnouncementWidget';
import HotTagDiscussion from '../components/HotTagDiscussion';
import ActiveCreatorTag from '../components/ActiveCreatorTag';

/**
 *  widget
 */
export default function allWidget() {
  extend(EndWidgetSection.prototype, 'view', function (vnode) {
    const isLogin = !!app.session.user;
    const tag = m.route.param('tags');

    if (!tag) {
      vnode.children = [...vnode.children, <IndexWidget />];
    } else {
      if (!isLogin) {
        vnode.children = [...vnode.children, <HotTagDiscussion/>, <ActiveCreatorTag/>];
      } else {
        vnode.children = [...vnode.children, <AnnouncementDiscussion/>, <HotTagDiscussion/>, <ActiveCreatorTag/>];
      }
    }
  });
}
